import { getSalesRankingLastUpdatedAt } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type SalesRankingLastUpdatedAtDTO,
  SalesRankingLastUpdatedAtDTOSchema,
} from './sales-ranking-last-updated-at.dto';

const transformLastUpdatedAtResponse = async (): Promise<SalesRankingLastUpdatedAtDTO> => {
  const { data } = await getSalesRankingLastUpdatedAt();

  return {
    lastUpdatedAt: data.lastUpdatedAt,
  };
};

export const getSalesRankingLastUpdatedAtService = withServiceErrorCapture(
  lazyPipe(
    transformLastUpdatedAtResponse,
    validateServiceResponse(SalesRankingLastUpdatedAtDTOSchema),
  ),
);
